<template>
  <div class="relative">
    <button
      @click="prev"
      :disabled="atBeginning"
      class="absolute left-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white/80 rounded-full shadow disabled:opacity-40"
      aria-label="Anterior"
    >
      <i class="ph ph-caret-left"></i>
    </button>

    <div ref="sliderRef" class="overflow-x-auto flex scroll-smooth">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="flex-shrink-0"
      >
        <img :src="item.src" :alt="item.alt || ''" class="w-full h-full object-cover" />
      </div>
    </div>

    <button
      @click="next"
      :disabled="atEnd"
      class="absolute right-2 top-1/2 -translate-y-1/2 z-10 w-8 h-8 flex items-center justify-center bg-white/80 rounded-full shadow disabled:opacity-40"
      aria-label="Siguiente"
    >
      <i class="ph ph-caret-right"></i>
    </button>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  items: { type: Array, default: () => [] },
  skip: { type: Number, default: 1 },
});

const sliderRef = ref(null);
const atBeginning = ref(true);
const atEnd = ref(false);
let observer = null;

function next() {
  const slider = sliderRef.value;
  if (!slider) return;
  const offset = slider.firstElementChild?.getBoundingClientRect().width ?? 0;
  slider.scrollTo({ left: slider.scrollLeft + offset * props.skip, behavior: 'smooth' });
}

function prev() {
  const slider = sliderRef.value;
  if (!slider) return;
  const offset = slider.firstElementChild?.getBoundingClientRect().width ?? 0;
  slider.scrollTo({ left: slider.scrollLeft - offset * props.skip, behavior: 'smooth' });
}

onMounted(() => {
  const slider = sliderRef.value;
  if (!slider || !slider.children.length) return;

  observer = new IntersectionObserver(
    (entries) => {
      const slideEls = slider.children;
      entries.forEach((entry) => {
        const isFirst = slideEls[0] === entry.target;
        const isLast = slideEls[slideEls.length - 1] === entry.target;

        if (entry.isIntersecting) {
          if (isFirst) atBeginning.value = true;
          if (isLast) atEnd.value = true;
        } else {
          if (isFirst) atBeginning.value = false;
          if (isLast) atEnd.value = false;
        }

        // Manage focusability of slides
        if (entry.isIntersecting) {
          entry.target.removeAttribute('tabindex');
        } else {
          entry.target.setAttribute('tabindex', '-1');
        }
      });
    },
    { threshold: 0.05 },
  );

  Array.from(slider.children).forEach((slide) => observer.observe(slide));
});

onUnmounted(() => observer?.disconnect());
</script>
